export enum ServiceTypes {
            SPOT = 1,
            DEDICATED = 2,
            REGULAR = 3
}
